import React, { useEffect } from "react";
import PageWrapper from "Components/PageWrapper";
import Footer from "Components/Footer";
import styled, { css } from "styled-components";
import Logo from "Components/Logo";
import Title, { TitleType } from "Components/Text/Title";
import TextParagraph from "Components/Text/TextParagraph";
import SourceVideo from "Components/SourceVideo";
import Stars from "Components/Stars";
import AboutSection from "Components/About/AboutSection";
import { DATA_INTRODUCE_TEXT, DATA_PROGRAM, DATA_PROCESS, DATA_INFO, DATA_INTRODUCE_GALLERY, DATA_SPONSOR } from "Data/about";
import AboutCard from "Components/About/AboutCard";
import AboutProcess from "Components/About/AboutProcess";
import AboutInfo from "Components/About/AboutInfo";
import { useHeaderState } from "Provider/AppProvider";
import useScroll from "Hooks/useScroll";
import useWindowSize from "Hooks/useWindowSize";
import { BREAKPOINT_MOBILE } from "Styles/media";
import AboutGallery from "Components/About/AboutGallery";
import { useAboutScroll } from "Provider/AboutProvider";
import AboutSponsor from "Components/About/AboutSponsor";

const Wrapper = styled(PageWrapper) <{ scrollDisable: boolean }>`
	padding: 0;
	${(props) => props.theme.color.appBg};

	${(props) =>
		props.scrollDisable &&
		css`
			overflow: hidden;
		`};
`;
const Cover = styled.div`
	height: 100vh;
	${(props) => props.theme.layout.center_flex};
	flex-direction: column;
`;

const LogoWrapper = styled.div`
	width: 20%;
	margin-top: 8%;
	min-width: 220px;
`;
const CoverLogo = styled(Logo)`
	width: 100%;
	position: relative;
	transform: translateX(5%);
`;

const TextWrapper = styled.div`
	margin-top: 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const SubTitle = styled(TextParagraph)`
	color: white;
	margin-bottom: 12px;
`;
const TitleCustom = styled(Title)`
	padding: 0;
	line-height: 1.6;
`;

const SubTitleCustom = styled(SubTitle)`
	opacity: 1;	
	margin-top:45px;
	&:first-child{
		margin-top:0px;
	}
	margin-bottom:15px;
`;

const About = () => {
	const { initHeaderState, setHeaderState } = useHeaderState();
	const { element, value } = useScroll();
	const { size } = useWindowSize();
	const { scrollDisable } = useAboutScroll();

	useEffect(() => {
		initHeaderState();
		return () => initHeaderState();
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (size.width > BREAKPOINT_MOBILE) return;
		setHeaderState((n) => ({
			...n,
			solid: value > 32
		}));
	}, [value, setHeaderState, size]);

	return (
		<Wrapper propsRef={element} scrollDisable={scrollDisable}>
			<Cover>
				<LogoWrapper>
					<CoverLogo />
				</LogoWrapper>
				<TextWrapper>
					<SubTitle value={"#1"} />
					<TitleCustom value={"Z플래닛을 여행하는"} type={TitleType.SM} />
					<TitleCustom value={"히치하이커를 위한 안내서"} type={TitleType.SM} />
				</TextWrapper>
			</Cover>

			<AboutSection title="introduce">
				<TextParagraph value={DATA_INTRODUCE_TEXT} />
				<AboutGallery data={DATA_INTRODUCE_GALLERY} />
			</AboutSection>

			<AboutSection title="program">
				<SubTitleCustom value={"인터랙티브 퍼포먼스 융합교육 프로그램 <Z플래닛을 여행하는 히치하이커를 위한 안내서>"} />
				<SourceVideo source={"0gGe4h5XhhI"} />
				<SubTitleCustom value={"요원들의 <Z플래닛 에피소드1 : 프리퀄>"} />
				<SourceVideo source={"KuMaKKM2yaw"} />
				<SubTitleCustom value={"인터랙티브 퍼포먼스 융합교육용 <42키트>"} />
				<SourceVideo source={"HxlFVC38N7U"} />
			</AboutSection>

			<AboutSection title="process">
				<AboutProcess data={DATA_PROCESS} />
			</AboutSection>

			<AboutSection title="sponsor">
				<AboutSponsor data={DATA_SPONSOR} />
			</AboutSection>

			<Stars count={40} />
			<Footer />
		</Wrapper>
	);
};

export default About;
